import React from 'react';

export default class SimpleForm extends React.Component {
  handleInputChange(event) {
    const { target } = event;
    const value = target.type === 'checkbox' ? target.checked : target.value;
    const { name } = target;
    
    this.setState(state => ({
      ...state,
      [name]: value,
    }));
  }
}
